<template>
  <div class="api-params-container">
    <h5>{{ $t('da_works.edit.work_edit_title') }}</h5>
    <div class="filter_container" v-if="modalData.work">
      <div class="row">
        <div class="col-lg-12">
          <label class="control-label pb-2">{{$t('da_works.edit.work_name')}}</label>
          <autocomplete-remote-search
              display-expr="name"
              value-expr="uuid"
              :value="modalData.work_uuid"
              @onChange="onWorkChanged"
              :by-key-method="getWork"
              :search-method="getWorks"
          />
        </div>
      </div>
      <div class="row">
        <div class="col-lg-12">
          <label class="control-label">{{$t('common.tractor')}}</label>
          <input v-model="modalData.workMachine.name" class="form-control" disabled/>
        </div>
      </div>

      <div class="row" v-if="loading">
        <div class="col-lg-12 load text-center" v-if="loading">
          <loader :loading="loading" size="sm"/>
        </div>
      </div>

      <div class="row">
        <div class="col-lg-12">
          <work-parcel-list :title="$t('da_works.edit.parcels')" :data="spcParcels"/>
        </div>
      </div>

    </div>


    <div class="dialog-footer-buttons">
      <b-button
          class="continue_button"
          variant="outline-secondary"
          size="sm"
          pill
          @click="save"
      >{{ $t('common.save')}}</b-button
      >
    </div>
    <toast-message ref="toastMessage"></toast-message>
  </div>
</template>

<script>
import {mapActions, mapGetters} from "vuex";
import {buildDefaultDropdownList} from "@/helpers/common";
import ToastMessage from "@/components/Mobile/toastMessage.vue";
import Loader from "@/components/Loader.vue";
import WorkParcelList from "@/pages/works/applyArticles/partials/WorkApiDialog/WorkParcelList/index.vue";
import CustomStore from "devextreme/data/custom_store";
import AutocompleteRemoteSearch from "@/components/Common/AutocompleteRemoteSearch.vue";
import {handleError} from "@/helpers/generalActions";

export default {
  props: ['show', 'data'],
  components: {
    AutocompleteRemoteSearch,
    WorkParcelList,
    Loader,
    ToastMessage,
  },
  data() {
    return {
      showWorkMachineSelector: false,
      modalData: this.data ?? {},
      loading: false,
      loaded: false,
    };
  },
  computed: {
    ...mapGetters({
      importConfigurations: 'importConfig/importConfigurations',
      tracktorApiSyncStatus: 'importConfig/tracktorApiSyncStatus',
      seasons: 'seasons/seasons',
      spcParcels: 'seasonOnParcelHasCulture/spcParcels',
      works: "works-manager/works",
      work: "works-manager/work",
    }),
    apiConfig() {
      return this.importConfigurations?.find(
          (config) =>
              config.import_type === 'SGPS_DASC_IMPORT' &&
              config.is_active === 1 &&
              config.source_type === "API_IMPORT" &&
              config.source_config_uuid
      );
    },
    seasonList() {
      let seasons = this.seasons ?? [];

      //filter for remote usage if set
      if (this.sourceType === 'remote') {
        seasons = this.seasons.filter((item) => {
          return Boolean(item.remote_id);
        });

        if (seasons.length === 0 && this.seasons.length > 0) {
          seasons.push({
            uuid: this.season_sync_key,
            name: '-' + this.$t('sync_seasons') + '-'
          })
        }
      }

      return buildDefaultDropdownList(seasons, null, {
        value: null,
        text: '-' + this.$t('select_season') + '-',
        subtext: null,
      });
    },
    worksDataStore() {
      return new CustomStore({
        key: 'uuid',
        byKey: uuid => this.getWork({
          uuid: uuid,
        }).then((res) => {
          console.log('res data', res.data);
          return res.data;
        }),
        load: (loadOptions) => {
          const search = loadOptions.searchValue || '';
          return this.getWorks({
            name: search
          })
          .then(res => res.data);
        }
      })
    }
  },
  methods: {
    ...mapActions({
      getImportConfigurations: 'importConfig/getImportConfigurations',
      getSeasons: 'seasons/getSeasons',
      syncTracktorApiProjects: "importConfig/syncTracktorApiProjects",
      getTracktorApiSyncStatus: 'importConfig/getTracktorApiSyncStatus',
      getSpcParcels: "seasonOnParcelHasCulture/getSpcParcels",
      getWorks: "works-manager/getWorks",
      getWork: "works-manager/getWork",
      updateWorkBulk :"seasonOnParcelHasCulture/updateWorkBulk",
    }),
    save() {
      const vm = this;
      if (vm.modalData.work_uuid) {
        const data = {
          works: [],
          work_date: vm.modalData.date,
          department_uuid: vm.modalData.department_uuid,
        };

        this.spcParcels.map((parcel) => {
          const parcelData = {
            spc_uuid: parcel?.spc_items[0],
            work_uuid: vm.modalData.work_uuid,
            parcel_uuid: parcel.uuid,
            net_surface_worked: parcel.surface_worked,
            api_sync_uuid: vm.modalData.work.api_sync_uuid,
          };
          data.works.push(parcelData);
        });

        this.updateWorkBulk(data).then((resp) => {
          this.showSuccess(resp.message);
          vm.$emit('onWorkParcelsSaved');
        }).catch((e) => {
          handleError(vm, e);
        }).finally(() => {
          vm.$emit('close');
        });

      } else {
        this.showError(this.$t('fill_out_error'));
      }
    },
    showError(message) {
      this.$refs.toastMessage.showError(message);
    },
    showSuccess(message) {
      this.$refs.toastMessage.showSuccess(message);
    },
    selectParcel(parcels) {
      console.log('selected parcels', parcels);
    },
    handleParcelListing() {
      const vm = this;
      this.loading = true;
      this.getSpcParcels({
        department_uuid: this.modalData.workListFilters.departments.join(','),
        work_uuid: this.modalData.work_uuid,
        date_from: this.modalData.work.date,
        date_to:  this.modalData.work.date,
        group_by: this.modalData.workListFilters.group_by,
        work_machine_uuid: this.modalData.workMachine.uuid,
        api_sync_uuid: this.modalData.work.api_sync_uuid,
      }).finally(() => {
        vm.loading = false;
        vm.loaded = true;
      });
    },
    onWorkChanged(workUUID) {
      this.modalData.work_uuid = workUUID;
    },
  },
  watch: {
    show: function (newVal) {

    },
    data: {
      handler: function (newVal) {
        this.$set(this, 'modalData', newVal);
        if (newVal && this.modalData && this.modalData.work && this.modalData.workMachine && !this.loaded) {
          this.handleParcelListing();
        }
      },
      deep: true,
    }
  }
};
</script>

<style>
@import "devextreme/dist/css/dx.light.css";
@import "@/assets/scss/digitalAgenda/daFilters.scss";

.flex-4 {
  flex: 4;
}

.flex-1 {
  flex: 1;
}
</style>
